/**
 * Dineo Design System - Shadows
 *
 * Warm-toned shadow system using rgba(26,23,16,...) (Espresso / neutral.950)
 * for a cohesive, organic feel. 25 entries as MUI expects (indices 0-24).
 */

export const shadows = [
  // 0 - none
  'none',
  // 1 - xs: subtle lift for cards at rest
  '0 1px 3px rgba(26,23,16,0.08)',
  // 2 - sm: slight elevation
  '0 2px 6px rgba(26,23,16,0.1)',
  // 3 - sm+: hover states
  '0 3px 8px rgba(26,23,16,0.1), 0 1px 2px rgba(26,23,16,0.06)',
  // 4 - md: raised cards
  '0 4px 12px rgba(26,23,16,0.1), 0 1px 3px rgba(26,23,16,0.06)',
  // 5 - md+
  '0 5px 14px rgba(26,23,16,0.1), 0 2px 4px rgba(26,23,16,0.06)',
  // 6 - lg: popovers, menus
  '0 6px 16px rgba(26,23,16,0.12), 0 2px 6px rgba(26,23,16,0.06)',
  // 7
  '0 7px 18px rgba(26,23,16,0.12), 0 3px 6px rgba(26,23,16,0.06)',
  // 8 - xl: modals, dialogs
  '0 8px 24px rgba(26,23,16,0.14), 0 3px 8px rgba(26,23,16,0.06)',
  // 9
  '0 9px 28px rgba(26,23,16,0.14), 0 4px 8px rgba(26,23,16,0.06)',
  // 10
  '0 10px 30px rgba(26,23,16,0.14), 0 4px 10px rgba(26,23,16,0.06)',
  // 11
  '0 11px 32px rgba(26,23,16,0.15), 0 5px 10px rgba(26,23,16,0.06)',
  // 12
  '0 12px 36px rgba(26,23,16,0.16), 0 5px 12px rgba(26,23,16,0.06)',
  // 13
  '0 13px 38px rgba(26,23,16,0.16), 0 6px 12px rgba(26,23,16,0.06)',
  // 14
  '0 14px 40px rgba(26,23,16,0.17), 0 6px 14px rgba(26,23,16,0.06)',
  // 15
  '0 15px 44px rgba(26,23,16,0.18), 0 7px 14px rgba(26,23,16,0.06)',
  // 16
  '0 16px 48px rgba(26,23,16,0.18), 0 7px 16px rgba(26,23,16,0.07)',
  // 17
  '0 17px 50px rgba(26,23,16,0.19), 0 8px 16px rgba(26,23,16,0.07)',
  // 18
  '0 18px 52px rgba(26,23,16,0.20), 0 8px 18px rgba(26,23,16,0.07)',
  // 19
  '0 19px 56px rgba(26,23,16,0.20), 0 9px 18px rgba(26,23,16,0.07)',
  // 20
  '0 20px 60px rgba(26,23,16,0.22), 0 9px 20px rgba(26,23,16,0.07)',
  // 21
  '0 21px 64px rgba(26,23,16,0.22), 0 10px 20px rgba(26,23,16,0.07)',
  // 22
  '0 22px 68px rgba(26,23,16,0.24), 0 10px 22px rgba(26,23,16,0.07)',
  // 23
  '0 23px 72px rgba(26,23,16,0.24), 0 11px 22px rgba(26,23,16,0.08)',
  // 24 - 2xl: maximum elevation
  '0 24px 80px rgba(26,23,16,0.26), 0 12px 24px rgba(26,23,16,0.08)',
];
